import psHttp from '@patsnap/common-ps-http';
import { coreBasicApiUrlPrefix, coreSearchApiUrlPrefix } from '../../config/constants';

export function getPatentApi (params) {
    return psHttp({
        url: `${coreSearchApiUrlPrefix}/view/srp/patents`,
        method: 'GET',
        params,
        transformCode: true
    });
}

export function getChemicalExtractApi (data) {
    return psHttp({
        url: `${coreSearchApiUrlPrefix}/view/chemical-extract`,
        method: 'POST',
        data,
        transformCode: true
    });
}

export function getAnalyticsDualViewSetting () {
    return psHttp({
        url: `${coreSearchApiUrlPrefix}/patent/view/dual-view/setting`,
        method: 'GET',
        transformCode: true
    }).then(({ data }) => {
        return data.data || {};
    });
}

export function setAnalyticsDualViewSetting (data) {
    return psHttp({
        url: `${coreSearchApiUrlPrefix}/patent/view/dual-view/setting`,
        method: 'PUT',
        data,
        transformCode: true
    }).then(({ data }) => {
        return data.data || {};
    });
}

export function getCompareWoldCloud({ leftPatentId, leftLang, rightPatentId, rightLang }) {
    return psHttp({
        url: `${coreSearchApiUrlPrefix}/view/compare/compare-word-cloud`,
        method: 'POST',
        data: [
            {
                patent_id: leftPatentId,
                lang: leftLang
            },
            {
                patent_id: rightPatentId,
                lang: rightLang
            }
        ],
        cache: true,
        uuid: `compare-word-cloud-${leftPatentId}-${leftLang}-${rightPatentId}-${rightLang}`,
        transformCode: true
    }).then(({ data }) => {
        return data.data;
    });
}

export function getCompareSimilarParagraphApi({
    source_patent_id,
    target_patent_id,
    lang,
    doc_type
}) {
    return psHttp({
        url: `${coreSearchApiUrlPrefix}/view/compare/compare-paragraph`,
        method: 'POST',
        data: {
            source_patent_id,
            target_patent_id,
            lang,
            doc_type
        },
        transformCode: true
    }).then(({ data }) => {
        return data.data;
    });
}

export function getCompareScoreApi({
    compare_id,
    source_patent_id,
    target_patent_id,
    lang
}) {
    return psHttp({
        url: `${coreSearchApiUrlPrefix}/view/compare/compare-score`,
        method: 'POST',
        data: {
            compare_id,
            source_patent_id,
            target_patent_id,
            lang
        },
        transformCode: true
    }).then(({ data }) => {
        return data.data;
    });
}

export function addComparePatentApi(data) {
    return psHttp({
        url: `${coreSearchApiUrlPrefix}/view/compare/compare-add`,
        method: 'POST',
        data,
        transformCode: true
    });
}

export function compareInitApi(data) {
    return psHttp({
        url: `${coreSearchApiUrlPrefix}/view/compare/compare-init`,
        method: 'POST',
        data,
        cache: true,
        transformCode: true
    }).then(({ data }) => {
        return data.data;
    });
}

export function getGPTSummary(patentId = '') {
    return psHttp({
        url: `${coreSearchApiUrlPrefix}/patent/id/${patentId}/ai_summary`,
        method: 'GET',
        cache: true,
        transformCode: true
    }).then(({ data }) => {
        return data.data;
    });
}

export function getGPTTranslate({ text = '', patentId = '', from = '', to = '', prompt = '' } = {}) {
    return psHttp({
        url: `${coreSearchApiUrlPrefix}/ai/translate`,
        method: 'POST',
        cache: true,
        transformCode: true,
        data: {
            text,
            from,
            to,
            patent_id: patentId,
            prompt,
        }
    }).then(({ data }) => {
        return data.data;
    });
}

// 专利分享签名接口
export function getPatentShareSignApi (patentId) {
    return psHttp({
        url: `${coreSearchApiUrlPrefix}/patent/view/id/${patentId}/patent-signature`,
        method: 'GET',
        transformCode: true,
        cache: true,
    }).then(({ data }) => {
        return data.data;
    });
}
